import LoopIcon from "@mui/icons-material/Loop";
import { Box, Typography } from "@mui/material";
import React from "react";
import { AvatarVideoData } from "../../../../Types/VideoSuite-Types";
import Skeleton from "../../../main-page/components/SettingPages/Help & Support/Skeleton";
import "../../View/VideoSuite.css";

interface AvatarCardProps {
  avatar: AvatarVideoData | undefined;
  openReplace: () => void;
  isLoading: boolean;
}

export const AvatarCard = ({
  avatar,
  openReplace,
  isLoading,
}: AvatarCardProps) => {
  return (
    <Box className="avatar-card-container">
      <Typography className="avatar-card-title" sx={{opacity:0.7}}>Avatar</Typography>
      <Box className="avatar-box">
        <Box className="avatar-data">
          {isLoading ? (
            <Skeleton width="25%" height="100%" margin="0" borderRadius="0" />
          ) : (
            <Box className="avatar-image">
              <img
                src={avatar?.preview_image_url}
                alt="avatar-img"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          )}

          <Box className="avatar-info">
            <Box className="avatar-details">
              {isLoading ? (
                <Skeleton
                  width="150px"
                  height="20px"
                  margin="0"
                  borderRadius="6px"
                />
              ) : (
                <Typography className="avatar-name">
                  {avatar?.avatar_name}
                </Typography>
              )}
              {isLoading ? (
                <Skeleton
                  width="110px"
                  height="15px"
                  margin="0"
                  borderRadius="6px"
                />
              ) : (
                <Typography className="avatar-gender">
                  {avatar?.gender}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        {isLoading ? (
          <Skeleton width="110px" height="44px" margin="m-2" borderRadius="12px" />
        ) : (
          <Box className="replace-avatar-box" onClick={openReplace}>
            <LoopIcon sx={{ fontSize: "1.3rem" }} />
            <Typography>Replace</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
